import { Map } from "immutable";
export const setFilterParam = (key, value, history)=>{
    let params = getCurrentFilterParams(history.location.search);
    params = value && value != "" ? params.set(key, value) : params.remove(key);
    const pathname = history.location.pathname;
    let query = createFilterQuery(params);
    history.push(`${pathname}${query}`);
};
export const createFilterQuery = (filterParams)=>{
    if (filterParams.isEmpty()) return '';
    const params = filterParams.mapEntries((param)=>{
        let [key, value] = param;
        return [
            key,
            value
        ];
    }).toArray();
    let search = new URLSearchParams(params);
    return `?${search.toString()}`;
};
export const getCurrentFilterParams = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.search;
    let params = new URLSearchParams(search);
    let filterParams = Map();
    params.forEach((value, key)=>{
        if (key == 'wanneer' || key == 'waar' || key == 'categorie') {
            filterParams = filterParams.set(key, value);
        }
    });
    return filterParams;
};
export const getCurrentFilterQuery = ()=>createFilterQuery(getCurrentFilterParams());
